import { render, staticRenderFns } from "./LocationPre.vue?vue&type=template&id=2f61b914&"
import script from "./LocationPre.vue?vue&type=script&lang=js&"
export * from "./LocationPre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports